/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 * 
 ********************************************************************!*/

import { IChatbotResult } from "@/api/bot";
import { IInvoiceResult, IPaymentMethodResult, ISubscriptionResult } from "@chatcaptain/types/billing";
import { IGroupResult, IUserResult } from "@chatcaptain/types/organization";
import { MutationTree } from "vuex";
import { IAdminState } from "./state";

export enum Mutations {
  SET_USERS = "SET_USERS",
  UPDATE_USER = "UPDATE_USER",
  SET_GROUPS = "SET_GROUPS",
  UPDATE_GROUP = "UPDATE_GROUP",
  SET_CHATBOTS = "SET_CHATBOTS",
  SET_SUBSCRIPTION = "SET_SUBSCRIPTION",
  SET_PAYMENT_METHODS = "SET_PAYMENT_METHODS",
  SET_INVOICES = "SET_INVOICES"
}

export interface IMutations<S = IAdminState> {
  [Mutations.SET_USERS](state: S, payload: IUserResult[]): void;
  [Mutations.UPDATE_USER](state: S, payload: IUserResult): void;
  [Mutations.SET_GROUPS](state: S, payload: IGroupResult[]): void;
  [Mutations.UPDATE_GROUP](state: S, payload: IGroupResult): void;
  [Mutations.SET_CHATBOTS](state: S, payload: IChatbotResult[]): void;
  [Mutations.SET_SUBSCRIPTION](state: S, payload: ISubscriptionResult | null): void;
  [Mutations.SET_PAYMENT_METHODS](state: S, payload: IPaymentMethodResult[]): void;
  [Mutations.SET_INVOICES](state: S, payload: IInvoiceResult[]): void;
}

export const mutations: MutationTree<IAdminState> & IMutations = {
  [Mutations.SET_USERS]: (state: IAdminState, users: IUserResult[]) => {
    state.users = users;
  },
  [Mutations.UPDATE_USER]: (state: IAdminState, user: IUserResult) => {
    const userId = user.id;
    const index = state.users.findIndex(el => el.id == userId);
    state.users[index] = user;
  },
  [Mutations.SET_GROUPS]: (state: IAdminState, groups: IGroupResult[]) => {
    state.groups = groups;
  },
  [Mutations.UPDATE_GROUP]: (state: IAdminState, group: IGroupResult) => {
    const groupId = group.id;
    const index = state.groups.findIndex(el => group.id == groupId);
    state.groups[index] = group;
  },
  [Mutations.SET_CHATBOTS]: (state: IAdminState, chatbots: IChatbotResult[]) => {
    state.chatbots = chatbots;
  },
  [Mutations.SET_SUBSCRIPTION]: (state: IAdminState, subscription: ISubscriptionResult | null) => {
    state.subscription = subscription;
  },
  [Mutations.SET_PAYMENT_METHODS]: (state: IAdminState, methods: IPaymentMethodResult[]) => {
    state.paymentMethods = methods;
  },
  [Mutations.SET_INVOICES]: (state: IAdminState, invoices: IInvoiceResult[]) => {
    state.invoices = invoices;
  },
}